import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const TIPOS_USUARIO = [
  { value:'MEDICO',        label:'Médico',          icon:'🩺', color:'var(--navy-lt)' },
  { value:'SECRETARIA',    label:'Secretaria',      icon:'💼', color:'var(--green)' },
  { value:'ADMINISTRADOR', label:'Administrador',   icon:'⚙️', color:'#1a2535' },
  { value:'ENFERMERIA',    label:'Enfermería',      icon:'💉', color:'#0891B2' },
  { value:'LABORATORIO',   label:'Laboratorio',     icon:'🔬', color:'#7C3AED' },
  { value:'OTRO',          label:'Otro',            icon:'👤', color:'#6B7280' },
];

const CHECKS_CONFIG = [
  { key:'CONTABILIDAD',   label:'Obligado a llevar contabilidad' },
  { key:'CONTRIBUYENTE',  label:'Contribuyente especial' },
  { key:'BLOQUEO_PAGO',  label:'Bloqueo forma de pago' },
  { key:'CONVENIO_SUC',  label:'Convenios por sucursal' },
  { key:'VADEMECUM',      label:'Usar varios vademécums' },
  { key:'CTRL_FECHAS',   label:'Control rango de fechas' },
  { key:'DESC_100',      label:'Descuento 100%' },
  { key:'GEN_DOCS',      label:'Generar documentos' },
];

const COLORS_CONFIG = [
  { key:'--navy',    label:'Color principal',    default:'#1a2535' },
  { key:'--accent',  label:'Color acento',        default:'#2e6da4' },
  { key:'--bg',      label:'Fondo general',       default:'#f0f4f8' },
  { key:'--text',    label:'Texto principal',     default:'#1a2535' },
  { key:'--border',  label:'Bordes',              default:'#dde3ec' },
  { key:'--green',   label:'Éxito',               default:'#1a7a4a' },
  { key:'--amber',   label:'Advertencia',         default:'#b85c00' },
  { key:'--red',     label:'Peligro',             default:'#b03030' },
];

const STORAGE_KEY = 'medisys_config';
const loadConfig  = () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY))||{}; } catch { return {}; } };
const saveConfig  = cfg => localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg));
const applyColors = colors => { const r=document.documentElement; Object.entries(colors).forEach(([k,v])=>r.style.setProperty(k,v)); };

const tipoInfo = v => TIPOS_USUARIO.find(t=>t.value===v)||TIPOS_USUARIO[5];

const FORM_EMPTY = { USUARIO:'', NOMBRES:'', PWD:'', CEDULA:'', TIPO_USUARIO:'MEDICO',
  ESPECIALIDAD:'', REGISTRO_MSP:'', SENESCYT:'', EMAIL:'', TELEFONO:'', DIRECCION:'' };

export default function Configuracion() {
  const { usuario } = useAuth();
  const esAdmin = usuario?.esDBA || ['ADMINISTRADOR'].includes((usuario?.tipo_usuario||'').toUpperCase());
  const esSecretaria = (usuario?.tipo_usuario||'').toUpperCase() === 'SECRETARIA' && !usuario?.esDBA;

  const [tab, setTab]         = useState('usuarios');
  const [tarifario, setTarifario] = useState([]);
  const [plantillasConsent, setPlantillasConsent] = useState([]);
  const [showFormConsent, setShowFormConsent] = useState(false);
  const [editConsentId, setEditConsentId] = useState(null);
  const [formConsent, setFormConsent] = useState({TITULO:'',CUERPO:'',REQUIERE_FIRMA_MEDICO:false,REQUIERE_FIRMA_TESTIGO:false});
  const [savingConsent, setSavingConsent] = useState(false);
  const [showNuevoServ, setShowNuevoServ] = useState(false);
  const [nuevoServ, setNuevoServ] = useState({SERVICIO:'',VALOR:0,APLICA_IVA:false,VALOR_MODIFICABLE:true});
  const [savingServ, setSavingServ] = useState(false);
  const [ivaGlobal, setIvaGlobal] = useState(15);
  const [savingTar, setSavingTar]   = useState(false);
  const [iaCfg,     setIaCfg]       = useState({api_key:'',activo:false,configurado:false});
  const [savingIA,  setSavingIA]    = useState(false);
  const [showKey,   setShowKey]     = useState(false);
  const [plantillasC, setPlantillasC] = useState([]);
  const [showFormPl,  setShowFormPl]  = useState(false);
  const [editPl,      setEditPl]      = useState(null);
  const [formPl, setFormPl] = useState({NOMBRE:'',DESCRIPCION:'',EVOLUCION:'',diagnosticos:[]});
  const [busqCie, setBusqCie] = useState('');
  const [sugsCie, setSugsCie] = useState([]);
  const [grupos,    setGrupos]    = useState([]);
  const [examList,  setExamList]  = useState([]);
  const [grupoSel,  setGrupoSel]  = useState('');
  const [examExp,   setExamExp]   = useState(null);
  const [extDatos,  setExtDatos]  = useState({});
  const [extSaving, setExtSaving] = useState(false);
  const [showFormEx, setShowFormEx] = useState(false);
  const [formEx,    setFormEx]    = useState({DETERMINACION:'',COD_TIPO_DETERMINACION:'',COD_SERVICIO:'',ORDEN_PRESENTACION:1});
  const [config, setConfig]   = useState(loadConfig);
  const [empresa, setEmpresa] = useState({
    RUC: config.empresa?.RUC||'',
    RAZON_SOCIAL: config.empresa?.RAZON_SOCIAL||'',
    NOMBRE_COMERCIAL: config.empresa?.NOMBRE_COMERCIAL||'',
    REPRESENTANTE: config.empresa?.REPRESENTANTE||'',
    DIRECCION: config.empresa?.DIRECCION||'',
    TELEFONO: config.empresa?.TELEFONO||'',
    EMAIL: config.empresa?.EMAIL||'',
    CODIGO_INEC: config.empresa?.CODIGO_INEC||'',
    TIPO_ESTABLECIMIENTO: config.empresa?.TIPO_ESTABLECIMIENTO||'Consultorio Médico',
    NIVEL_ATENCION: config.empresa?.NIVEL_ATENCION||'Primer Nivel',
    PROVINCIA: config.empresa?.PROVINCIA||'',
    CANTON: config.empresa?.CANTON||'',
    PARROQUIA: config.empresa?.PARROQUIA||'',
    DIRECTOR_MEDICO: config.empresa?.DIRECTOR_MEDICO||'',
    CARGO_DIRECTOR: config.empresa?.CARGO_DIRECTOR||'Director/a Médico/a',
    REGISTRO_MSP_DIR: config.empresa?.REGISTRO_MSP_DIR||'',
    HORAS_EDICION: config.empresa?.HORAS_EDICION||72,
    POLITICA_PRIVACIDAD_HC: config.empresa?.POLITICA_PRIVACIDAD_HC||'RESTRINGIDA',
  });
  const [checks, setChecks]   = useState(config.checks||{});
  const [colors, setColors]   = useState(config.colors||Object.fromEntries(COLORS_CONFIG.map(c=>[c.key,c.default])));
  const [logo, setLogo]       = useState(config.logo||null);
  const [toast, setToast]     = useState('');

  /* Usuarios */
  const [usuarios, setUsuarios]   = useState([]);
  const [filtro, setFiltro]       = useState('');
  const [filtroTipo, setFTipo]    = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editUser, setEditUser]   = useState(null);
  const [form, setForm]           = useState(FORM_EMPTY);
  const [saving, setSaving]       = useState(false);
  const [errMsg, setErrMsg]       = useState('');
  const [firmaInfo, setFirmaInfo] = useState({});
  const [p12Pass, setP12Pass]     = useState('');
  const [firmaTexto, setFirmaTxt] = useState('');
  const [subiendo, setSubiendo]   = useState('');
  const logoRef = useRef();

  useEffect(()=>{ cargarUsuarios(); },[]);
  useEffect(()=>{
    if(tab==='ia'){
      api.get('/historia/ia-config').then(r=>setIaCfg(c=>({...c,...r.data}))).catch(()=>{});
    }
    if(tab==='plantillas'){
      api.get(`/historia/plantillas-consulta?medico=${usuario?.usuario}`)
        .then(r=>setPlantillasC(r.data||[])).catch(()=>{});
    }
    if(tab==='consentimientos'){
      api.get('/historia/plantillas-consentimiento')
        .then(r=>setPlantillasConsent(r.data||[])).catch(()=>{});
    }
    if(tab==='examenes'){
      api.get('/laboratorio/config/grupos').then(r=>setGrupos(r.data||[])).catch(()=>{});
    }
    if(tab==='tarifario'){
      api.get('/configuracion/tarifario')
        .then(r=>{ setTarifario(r.data.servicios||[]); setIvaGlobal(r.data.iva_global||15); })
        .catch(()=>{});
    }
    if(tab==='general'){
      api.get('/configuracion/ms-config')
        .then(r=>{
          if(r.data && Object.keys(r.data).length > 0){
            setEmpresa(ep=>({...ep,...r.data}));
          }
        })
        .catch(()=>{});
    }
    if(tab==='estilos'){
      api.get('/configuracion/ms-config')
        .then(r=>{
          if(r.data?.LOGO_PATH){
            const base=(process.env.REACT_APP_API_URL||'').replace('/api','').replace(/\/$/,'');
            setLogo(`${base}${r.data.LOGO_PATH}`);
          }
        })
        .catch(()=>{});
    }
  },[tab]);
  useEffect(()=>{ applyColors(colors); },[colors]);

  const cargarUsuarios = async () => {
    try{
      const{data}=await api.get('/configuracion/usuarios');
      setUsuarios(data);
    }catch(e){
      showToast('✗ No se pudo cargar la lista de usuarios: ' + (e.response?.data?.error||e.message));
    }
  };

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),2500); };

  const abrirNuevo = () => {
    setEditUser(null); setForm(FORM_EMPTY); setErrMsg(''); setShowModal(true);
  };

  const abrirEditar = async u => {
    setEditUser(u.USUARIO);
    setForm({ USUARIO:u.USUARIO, NOMBRES:u.NOMBRES||'', PWD:'', CEDULA:u.CEDULA||'',
      TIPO_USUARIO:u.TIPO_USUARIO||'MEDICO', ESPECIALIDAD:u.ESPECIALIDAD||'',
      REGISTRO_MSP:u.REGISTRO_MSP||'', SENESCYT:u.SENESCYT||'',
      EMAIL:u.EMAIL||'', TELEFONO:u.TELEFONO||'', DIRECCION:u.DIRECCION||'' });
    setErrMsg(''); setP12Pass(''); setSubiendo('');
    setShowModal(true);
    try {
      const{data}=await api.get(`/configuracion/usuarios/${u.USUARIO}/p12-info`);
      setFirmaInfo(data);
      setFirmaTxt(data.firma_texto||'');
    } catch { setFirmaInfo({}); }
  };

  const guardarUsuario = async () => {
    if(!form.NOMBRES.trim()||(!editUser&&!form.USUARIO.trim())||(!editUser&&!form.PWD.trim())){
      setErrMsg('Usuario, nombre y contraseña son obligatorios'); return;
    }
    setSaving(true); setErrMsg('');
    try{
      if(editUser){
        await api.put(`/configuracion/usuarios/${editUser}`, form);
      } else {
        await api.post('/configuracion/usuarios', form);
      }
      setShowModal(false); cargarUsuarios();
      showToast(editUser ? '✓ Usuario actualizado' : '✓ Usuario creado');
    }catch(e){ setErrMsg(e.response?.data?.error||e.message); }
    finally{ setSaving(false); }
  };

  const toggleActivo = async (usuario, activo) => {
    try{
      await api.patch(`/configuracion/usuarios/${usuario}/toggle`);
      cargarUsuarios();
      showToast(activo ? 'Usuario desactivado' : 'Usuario activado');
    }catch{}
  };

  const guardarGeneral = async () => {
    const cfg = { empresa, checks, colors, logo };
    applyColors(colors);
    // Guardar también en BD
    try{
      await api.put('/configuracion/ms-config', {
        RUC: empresa.RUC, RAZON_SOCIAL: empresa.RAZON_SOCIAL,
        NOMBRE_ESTABLECIMIENTO: empresa.NOMBRE_COMERCIAL,
        REPRESENTANTE_LEGAL: empresa.REPRESENTANTE,
        DIRECCION: empresa.DIRECCION,
        TELEFONO_EMPRESA: empresa.TELEFONO,
        EMAIL_EMPRESA: empresa.EMAIL,
        // Campos MSP
        CODIGO_INEC:          empresa.CODIGO_INEC,
        TIPO_ESTABLECIMIENTO: empresa.TIPO_ESTABLECIMIENTO,
        NIVEL_ATENCION:       empresa.NIVEL_ATENCION,
        PROVINCIA:            empresa.PROVINCIA,
        CANTON:               empresa.CANTON,
        PARROQUIA:            empresa.PARROQUIA,
        DIRECTOR_MEDICO:      empresa.DIRECTOR_MEDICO,
        CARGO_DIRECTOR:       empresa.CARGO_DIRECTOR,
        REGISTRO_MSP_DIR:     empresa.REGISTRO_MSP_DIR,
        HORAS_EDICION:        empresa.HORAS_EDICION || 72,
        POLITICA_PRIVACIDAD_HC: empresa.POLITICA_PRIVACIDAD_HC || 'RESTRINGIDA',
        COLOR_PRIMARIO:   colors['--navy']   || '#1a2535',
        COLOR_ACENTO:     colors['--accent'] || 'var(--navy-lt)',
        COLOR_ACENTO_LT:  colors['--bg']     || '#f0f4f8',
      });
    }catch(e){ console.error(e); }
    saveConfig(cfg); setConfig(cfg);
    showToast('✓ Configuración guardada');
  };

  const usuariosFiltrados = usuarios.filter(u => {
    const q = filtro.toLowerCase();
    const matchQ = !q || (u.NOMBRES||'').toLowerCase().includes(q) || (u.USUARIO||'').toLowerCase().includes(q);
    const matchT = !filtroTipo || u.TIPO_USUARIO === filtroTipo;
    return matchQ && matchT;
  });

  const TABS_ALL = [
    {id:'usuarios',        icon:'👥', label:'Usuarios y roles',       admin: false},
    {id:'general',         icon:'⚙',  label:'Configuración general',  admin: true},
    {id:'estilos',         icon:'🎨', label:'Estilos e identidad',    admin: true},
    {id:'tarifario',       icon:'💲', label:'Tarifario',              admin: false},
    {id:'examenes',        icon:'🧪', label:'Exámenes y grupos',      admin: true},
    {id:'plantillas',      icon:'📋', label:'Plantillas de consulta', admin: false},
    {id:'consentimientos', icon:'✍️', label:'Consentimientos',        admin: false},
    {id:'ia',              icon:'🤖', label:'Asistente IA',           admin: true},
  ];
  const TABS = esAdmin ? TABS_ALL : TABS_ALL.filter(t => !t.admin);

  return (
    <div className="fade-up" style={{position:'relative'}}>
      {toast&&<div style={{position:'fixed',top:20,right:24,background:'var(--green)',color:'#fff',
        padding:'9px 18px',borderRadius:8,fontSize:12,fontWeight:600,zIndex:999,boxShadow:'0 4px 12px rgba(0,0,0,.2)'}}>
        {toast}</div>}

      {/* Tabs */}
      <div style={{display:'flex',gap:8,marginBottom:18,flexWrap:'wrap'}}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)}
            className={`btn ${tab===t.id?'btn-primary':''}`} style={{gap:7}}>
            <span style={{fontSize:13}}>{t.icon}</span> {t.label}
          </button>
        ))}
      </div>

      {/* ═══ USUARIOS ═══════════════════════════════════════ */}
      {tab==='usuarios'&&(
        <div>
          {/* Header */}
          <div style={{display:'flex',gap:10,marginBottom:14,alignItems:'center',flexWrap:'wrap'}}>
            <input className="form-control" style={{maxWidth:260}} placeholder="Buscar usuario..."
              value={filtro} onChange={e=>setFiltro(e.target.value)}/>
            <select className="form-control" style={{maxWidth:180}} value={filtroTipo} onChange={e=>setFTipo(e.target.value)}>
              <option value="">Todos los tipos</option>
              {TIPOS_USUARIO.map(t=><option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
            <div style={{marginLeft:'auto'}}>
              <button className="btn btn-primary" onClick={abrirNuevo}>+ Nuevo usuario</button>
            </div>
          </div>

          {/* Stats por tipo */}
          <div style={{display:'flex',gap:8,marginBottom:14,flexWrap:'wrap'}}>
            {TIPOS_USUARIO.map(t=>{
              const cnt = usuarios.filter(u=>u.TIPO_USUARIO===t.value).length;
              if(!cnt) return null;
              return(
                <div key={t.value} onClick={()=>setFTipo(filtroTipo===t.value?'':t.value)}
                  style={{background:filtroTipo===t.value?t.color:'var(--bg)',color:filtroTipo===t.value?'#fff':'var(--text2)',
                    border:`1px solid ${t.color}30`,borderRadius:20,padding:'4px 12px',fontSize:11,
                    cursor:'pointer',display:'flex',alignItems:'center',gap:5,fontWeight:500,transition:'all .15s'}}>
                  <span>{t.icon}</span> {t.label} ({cnt})
                </div>
              );
            })}
          </div>

          {/* Tabla */}
          <div className="table-card">
            <div className="table-header">
              <span className="card-title">Usuarios del sistema ({usuariosFiltrados.length})</span>
            </div>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Usuario</th><th>Nombre</th><th>Tipo</th>
                    <th>Especialidad / Registro</th><th>Email</th>
                    <th>Estado</th><th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {usuariosFiltrados.length===0
                    ? <tr><td colSpan={7} className="empty-state">Sin usuarios</td></tr>
                    : usuariosFiltrados.map(u=>{
                        const tipo = tipoInfo(u.TIPO_USUARIO);
                        return(
                          <tr key={u.USUARIO} style={{opacity:u.ACTIVO?1:.5}}>
                            <td style={{fontWeight:700,color:'var(--navy)'}}>{u.USUARIO}</td>
                            <td style={{fontWeight:500}}>{u.NOMBRES}</td>
                            <td>
                              <span style={{background:tipo.color+'18',color:tipo.color,
                                padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:500,
                                display:'inline-flex',alignItems:'center',gap:4}}>
                                {tipo.icon} {tipo.label}
                              </span>
                            </td>
                            <td style={{fontSize:11,color:'var(--text2)'}}>
                              {u.ESPECIALIDAD&&<div style={{fontWeight:500}}>{u.ESPECIALIDAD}</div>}
                              {u.REGISTRO_MSP&&<div style={{color:'var(--text3)'}}>MSP: {u.REGISTRO_MSP}</div>}
                              {u.SENESCYT&&<div style={{color:'var(--text3)'}}>SENESCYT: {u.SENESCYT}</div>}
                              {!u.ESPECIALIDAD&&!u.REGISTRO_MSP&&'—'}
                            </td>
                            <td style={{color:'var(--text3)',fontSize:11}}>{u.EMAIL||'—'}</td>
                            <td>
                              <span className={`badge ${u.ACTIVO?'badge-green':''}`}
                                style={!u.ACTIVO?{background:'var(--border)',color:'var(--text3)'}:{}}>
                                {u.ACTIVO?'Activo':'Inactivo'}
                              </span>
                            </td>
                            <td>
                              <div style={{display:'flex',gap:4}}>
                                <button className="btn btn-sm" style={{padding:'3px 8px',fontSize:11}}
                                  onClick={()=>abrirEditar(u)}>✏️ Editar</button>
                                <button className="btn btn-sm" style={{padding:'3px 8px',fontSize:11,
                                  color:u.ACTIVO?'var(--red)':'var(--green)'}}
                                  onClick={()=>toggleActivo(u.USUARIO,u.ACTIVO)}>
                                  {u.ACTIVO?'Desactivar':'Activar'}
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ═══ GENERAL ════════════════════════════════════════ */}
      {tab==='general'&&(
        <div className="card" style={{padding:0}}>
          <div className="card-header"><span className="card-title">Datos del establecimiento</span></div>
          <div style={{padding:'0 20px'}}>

            {/* ── Sección: Identificación ── */}
            <div style={{fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px',
              color:'var(--text3)',padding:'12px 0 4px'}}>Identificación del establecimiento</div>
            {[{key:'RUC',label:'RUC',req:true,half:true},
              {key:'CODIGO_INEC',label:'Código INEC / MSP',half:true},
              {key:'RAZON_SOCIAL',label:'Razón social'},
              {key:'NOMBRE_COMERCIAL',label:'Nombre comercial',req:true},
              {key:'REPRESENTANTE',label:'Representante legal',req:true},
            ].map(f=>(
              <div key={f.key} style={{display:'flex',alignItems:'center',padding:'9px 0',borderBottom:'1px solid var(--bg)'}}>
                <div style={{width:220,fontSize:12,color:'var(--text2)',fontWeight:500,flexShrink:0}}>
                  {f.label}{f.req&&<span style={{color:'var(--red)'}}> *</span>}
                </div>
                <input className="form-control" style={{maxWidth:f.half?240:'100%'}}
                  value={empresa[f.key]||''}
                  onChange={e=>setEmpresa(ep=>({...ep,[f.key]:e.target.value}))}/>
              </div>
            ))}

            {/* Tipo y nivel — selects */}
            {[
              {key:'TIPO_ESTABLECIMIENTO', label:'Tipo de establecimiento', opts:[
                'Consultorio Médico','Centro de Salud Tipo A','Centro de Salud Tipo B',
                'Centro de Salud Tipo C','Hospital Básico','Hospital General','Clínica']},
              {key:'NIVEL_ATENCION', label:'Nivel de atención', opts:[
                'Primer Nivel','Segundo Nivel','Tercer Nivel']},
            ].map(f=>(
              <div key={f.key} style={{display:'flex',alignItems:'center',padding:'9px 0',borderBottom:'1px solid var(--bg)'}}>
                <div style={{width:220,fontSize:12,color:'var(--text2)',fontWeight:500,flexShrink:0}}>{f.label}</div>
                <select className="form-control" style={{maxWidth:320}}
                  value={empresa[f.key]||''}
                  onChange={e=>setEmpresa(ep=>({...ep,[f.key]:e.target.value}))}>
                  {f.opts.map(o=><option key={o} value={o}>{o}</option>)}
                </select>
              </div>
            ))}

            {/* ── Sección: Ubicación ── */}
            <div style={{fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px',
              color:'var(--text3)',padding:'14px 0 4px'}}>Ubicación</div>
            {[
              {key:'PROVINCIA',label:'Provincia',half:true},
              {key:'CANTON',label:'Cantón',half:true},
              {key:'PARROQUIA',label:'Parroquia',half:true},
              {key:'DIRECCION',label:'Dirección completa'},
              {key:'TELEFONO',label:'Teléfono',half:true},
              {key:'EMAIL',label:'Email institucional',half:true},
            ].map(f=>(
              <div key={f.key} style={{display:'flex',alignItems:'center',padding:'9px 0',borderBottom:'1px solid var(--bg)'}}>
                <div style={{width:220,fontSize:12,color:'var(--text2)',fontWeight:500,flexShrink:0}}>{f.label}</div>
                <input className="form-control" style={{maxWidth:f.half?240:'100%'}}
                  value={empresa[f.key]||''}
                  onChange={e=>setEmpresa(ep=>({...ep,[f.key]:e.target.value}))}/>
              </div>
            ))}

            {/* ── Sección: Director médico (para firma en documentos MSP) ── */}
            <div style={{fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px',
              color:'var(--text3)',padding:'14px 0 4px'}}>Director/a médico/a — firma en documentos MSP</div>
            {[
              {key:'DIRECTOR_MEDICO',label:'Nombre completo',req:true},
              {key:'CARGO_DIRECTOR',label:'Cargo',half:true},
              {key:'REGISTRO_MSP_DIR',label:'Registro MSP',half:true},
            ].map(f=>(
              <div key={f.key} style={{display:'flex',alignItems:'center',padding:'9px 0',borderBottom:'1px solid var(--bg)'}}>
                <div style={{width:220,fontSize:12,color:'var(--text2)',fontWeight:500,flexShrink:0}}>
                  {f.label}{f.req&&<span style={{color:'var(--red)'}}> *</span>}
                </div>
                <input className="form-control" style={{maxWidth:f.half?240:'100%'}}
                  value={empresa[f.key]||''}
                  onChange={e=>setEmpresa(ep=>({...ep,[f.key]:e.target.value}))}/>
              </div>
            ))}

            {/* ── Sección: Control de historia clínica ── */}
            <div style={{fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px',
              color:'var(--text3)',padding:'14px 0 4px'}}>Control de historia clínica</div>
            <div style={{display:'flex',alignItems:'center',padding:'9px 0',borderBottom:'1px solid var(--bg)'}}>
              <div style={{width:220,flexShrink:0}}>
                <div style={{fontSize:12,color:'var(--text2)',fontWeight:500}}>Horas para edición libre</div>
                <div style={{fontSize:10,color:'var(--text3)',marginTop:2}}>
                  El médico puede editar sin autorización dentro de este plazo desde la creación
                </div>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <input type="number" className="form-control" style={{width:90,textAlign:'right',fontWeight:600}}
                  min={1} max={168} value={empresa.HORAS_EDICION||72}
                  onChange={e=>setEmpresa(ep=>({...ep,HORAS_EDICION:parseInt(e.target.value)||72}))}/>
                <span style={{fontSize:12,color:'var(--text2)'}}>horas</span>
                <span style={{fontSize:11,color:'var(--text3)'}}>
                  ({Math.floor((empresa.HORAS_EDICION||72)/24)}d {(empresa.HORAS_EDICION||72)%24}h)
                </span>
              </div>
            </div>
            <div style={{display:'flex',alignItems:'center',padding:'9px 0',borderBottom:'1px solid var(--bg)'}}>
              <div style={{width:220,flexShrink:0}}>
                <div style={{fontSize:12,color:'var(--text2)',fontWeight:500}}>Privacidad del historial clínico</div>
                <div style={{fontSize:10,color:'var(--text3)',marginTop:2}}>
                  Quién puede ver las consultas registradas por otro médico
                </div>
              </div>
              <select className="form-control" style={{maxWidth:280}}
                value={empresa.POLITICA_PRIVACIDAD_HC||'RESTRINGIDA'}
                onChange={e=>setEmpresa(ep=>({...ep,POLITICA_PRIVACIDAD_HC:e.target.value}))}>
                <option value="RESTRINGIDA">Restringida — solo con interconsulta</option>
                <option value="ABIERTA">Abierta — cualquier médico ve todo</option>
              </select>
            </div>
            <div style={{padding:'12px 0 6px',fontSize:11,fontWeight:700,textTransform:'uppercase',
              letterSpacing:'.5px',color:'var(--text3)'}}>Opciones del sistema</div>
            {CHECKS_CONFIG.map(c=>(
              <div key={c.key} style={{display:'flex',alignItems:'center',gap:12,padding:'8px 0',
                borderBottom:'1px solid var(--bg)',cursor:'pointer'}}
                onClick={()=>setChecks(ch=>({...ch,[c.key]:!ch[c.key]}))}>
                <div style={{width:20,height:20,borderRadius:5,flexShrink:0,display:'flex',alignItems:'center',
                  justifyContent:'center',background:checks[c.key]?'var(--navy)':'var(--surface)',
                  border:`2px solid ${checks[c.key]?'var(--navy)':'var(--border)'}`,transition:'all .15s'}}>
                  {checks[c.key]&&<span style={{color:'#fff',fontSize:11,fontWeight:700}}>✓</span>}
                </div>
                <span style={{fontSize:12,color:'var(--text2)'}}>{c.label}</span>
              </div>
            ))}
          </div>
          <div style={{padding:'16px 20px',display:'flex',gap:10}}>
            <button className="btn btn-primary" onClick={guardarGeneral}>Guardar cambios</button>
          </div>
        </div>
      )}

      {/* ═══ ESTILOS ════════════════════════════════════════ */}
      {tab==='estilos'&&(
        <div style={{display:'flex',flexDirection:'column',gap:16}}>
          <div className="card">
            <div className="card-header"><span className="card-title">Logo del establecimiento</span></div>
            <div style={{padding:'0 20px 20px'}}>
              <div onClick={()=>logoRef.current.click()}
                style={{border:'2px dashed var(--border)',borderRadius:10,padding:24,textAlign:'center',
                  background:'var(--surface2)',cursor:'pointer',marginBottom:12}}>
                {logo?<img src={logo} alt="Logo" style={{maxHeight:60,maxWidth:220,objectFit:'contain'}}/>
                  :<><div style={{fontSize:28,opacity:.3,marginBottom:6}}>🏥</div>
                    <div style={{fontSize:12,color:'var(--text3)'}}>Clic para subir el logo</div></>}
              </div>
              <input ref={logoRef} type="file" accept="image/*" style={{display:'none'}} onChange={async e=>{
                const f=e.target.files[0]; if(!f) return;
                const fd=new FormData(); fd.append('logo',f);
                try{
                  const {data}=await api.post('/configuracion/logo',fd,{headers:{'Content-Type':'multipart/form-data'}});
                  const base=(process.env.REACT_APP_API_URL||'').replace('/api','').replace(/\/$/,'');
                  setLogo(`${base}${data.LOGO_PATH}?t=${Date.now()}`);
                  showToast('✓ Logo guardado');
                }catch(err){ showToast('Error al subir el logo: '+(err.response?.data?.error||err.message)); }
              }}/>
              {logo&&<button className="btn" style={{fontSize:11,color:'var(--red)'}} onClick={async()=>{
                try{ await api.delete('/configuracion/logo'); setLogo(null); showToast('Logo eliminado'); }
                catch(err){ showToast('Error: '+(err.response?.data?.error||err.message)); }
              }}>Eliminar</button>}
            </div>
          </div>
          <div className="card">
            <div className="card-header"><span className="card-title">Colores institucionales</span></div>
            <div style={{padding:'0 20px'}}>
              <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
                {COLORS_CONFIG.map(c=>(
                  <div key={c.key} style={{display:'flex',flexDirection:'column',gap:5}}>
                    <div style={{fontSize:11,color:'var(--text2)',fontWeight:600}}>{c.label}</div>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <div style={{width:32,height:26,borderRadius:5,background:colors[c.key],
                        border:'1px solid var(--border)',cursor:'pointer',position:'relative'}}
                        onClick={()=>document.getElementById('cp-'+c.key.replace('--','')).click()}>
                        <input id={'cp-'+c.key.replace('--','')} type="color" value={colors[c.key]}
                          style={{opacity:0,width:0,height:0,position:'absolute'}}
                          onInput={e=>setColors(cl=>({...cl,[c.key]:e.target.value}))}/>
                      </div>
                      <input style={{flex:1,padding:'4px 6px',border:'1px solid var(--border)',borderRadius:5,
                        fontSize:10,fontFamily:'monospace',background:'var(--surface2)',outline:'none'}}
                        value={colors[c.key]} maxLength={7}
                        onChange={e=>/^#[0-9a-fA-F]{6}$/.test(e.target.value)&&setColors(cl=>({...cl,[c.key]:e.target.value}))}/>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{padding:'14px 20px',display:'flex',gap:10}}>
              <button className="btn btn-primary" onClick={guardarGeneral}>Guardar colores</button>
              <button className="btn" onClick={()=>setColors(Object.fromEntries(COLORS_CONFIG.map(c=>[c.key,c.default])))}>
                Restaurar por defecto
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ═══ MODAL USUARIO ══════════════════════════════════ */}
      {showModal&&createPortal(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',zIndex:9999,
          display:'flex',alignItems:'center',justifyContent:'center'}}
          onClick={e=>e.target===e.currentTarget&&setShowModal(false)}>
          <div style={{background:'var(--bg)',borderRadius:14,width:640,
            maxHeight:'85vh',display:'flex',flexDirection:'column',
            border:'0.5px solid var(--border)',margin:'0 16px'}}>
            {/* Header fijo */}
            <div style={{padding:'14px 20px',borderBottom:'0.5px solid var(--border)',
              display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
              <span style={{fontSize:14,fontWeight:500}}>
                {editUser ? `Editar usuario — ${editUser}` : 'Nuevo usuario'}
              </span>
              <button className="btn btn-sm" onClick={()=>setShowModal(false)}>✕</button>
            </div>

            <div style={{padding:20,display:'flex',flexDirection:'column',gap:14,overflowY:'auto',flex:1}}>
              {errMsg&&<div style={{padding:'8px 12px',borderRadius:8,background:'#FCEBEB',color:'#A32D2D',fontSize:12}}>{errMsg}</div>}

              {/* Tipo de usuario */}
              <div>
                <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'.4px',
                  color:'var(--text3)',marginBottom:8}}>Tipo de usuario</div>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {TIPOS_USUARIO.map(t=>(
                    <div key={t.value} onClick={()=>setForm(f=>({...f,TIPO_USUARIO:t.value}))}
                      style={{padding:'7px 14px',borderRadius:8,cursor:'pointer',fontSize:12,
                        display:'flex',alignItems:'center',gap:5,transition:'all .15s',fontWeight:500,
                        background:form.TIPO_USUARIO===t.value?t.color:'var(--surface)',
                        color:form.TIPO_USUARIO===t.value?'#fff':'var(--text2)',
                        border:`1px solid ${form.TIPO_USUARIO===t.value?t.color:'var(--border)'}`}}>
                      {t.icon} {t.label}
                    </div>
                  ))}
                </div>
              </div>

              {/* Datos básicos */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                {!editUser&&(
                  <div className="form-group">
                    <label className="form-label">Usuario (login) *</label>
                    <input className="form-control" placeholder="Ej: JPEREZ" style={{textTransform:'uppercase'}}
                      value={form.USUARIO} onChange={e=>setForm(f=>({...f,USUARIO:e.target.value.toUpperCase()}))}/>
                  </div>
                )}
                <div className="form-group" style={!editUser?{}:{gridColumn:'1/-1'}}>
                  <label className="form-label">Nombre completo *</label>
                  <input className="form-control" placeholder="DR. JUAN PÉREZ"
                    value={form.NOMBRES} onChange={e=>setForm(f=>({...f,NOMBRES:e.target.value}))}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Cédula del profesional</label>
                  <input className="form-control" placeholder="1234567890"
                    value={form.CEDULA||''} onChange={e=>setForm(f=>({...f,CEDULA:e.target.value}))}/>
                </div>
                <div className="form-group">
                  <label className="form-label">{editUser?'Nueva contraseña (dejar vacío para no cambiar)':'Contraseña *'}</label>
                  <input className="form-control" type="password" placeholder="••••••••"
                    value={form.PWD} onChange={e=>setForm(f=>({...f,PWD:e.target.value}))}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input className="form-control" type="email" placeholder="doctor@clinica.com"
                    value={form.EMAIL} onChange={e=>setForm(f=>({...f,EMAIL:e.target.value}))}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Teléfono</label>
                  <input className="form-control" placeholder="09XXXXXXXX"
                    value={form.TELEFONO} onChange={e=>setForm(f=>({...f,TELEFONO:e.target.value}))}/>
                </div>
              </div>

              {/* Datos médicos (solo para MEDICO y ENFERMERIA) */}
              {['MEDICO','ENFERMERIA'].includes(form.TIPO_USUARIO)&&(
                <div style={{background:'var(--surface)',borderRadius:8,padding:14,
                  border:'0.5px solid var(--border)'}}>
                  <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'.4px',
                    color:'var(--navy-lt)',marginBottom:10}}>🩺 Datos profesionales</div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                    <div className="form-group" style={{gridColumn:'1/-1'}}>
                      <label className="form-label">Especialidad</label>
                      <input className="form-control" placeholder="Ej: Medicina General, Endocrinología..."
                        value={form.ESPECIALIDAD} onChange={e=>setForm(f=>({...f,ESPECIALIDAD:e.target.value}))}/>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Registro MSP</label>
                      <input className="form-control" placeholder="N° registro Ministerio"
                        value={form.REGISTRO_MSP} onChange={e=>setForm(f=>({...f,REGISTRO_MSP:e.target.value}))}/>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Registro SENESCYT</label>
                      <input className="form-control" placeholder="N° registro SENESCYT"
                        value={form.SENESCYT} onChange={e=>setForm(f=>({...f,SENESCYT:e.target.value}))}/>
                    </div>
                  </div>
                </div>
              )}
              {/* ── Sección Firmas (solo médicos) ── */}
              {['MEDICO','ENFERMERIA'].includes(form.TIPO_USUARIO)&&editUser&&(
                <div style={{background:'#F8F6FF',borderRadius:8,padding:14,
                  border:'0.5px solid #AFA9EC'}}>
                  <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',
                    letterSpacing:'.4px',color:'var(--navy-lt)',marginBottom:12}}>
                    🔐 Firma electrónica y visual
                  </div>

                  {/* Firma como texto */}
                  <div className="form-group" style={{marginBottom:10}}>
                    <label className="form-label">Firma como texto</label>
                    <div style={{display:'flex',gap:6}}>
                      <input className="form-control" placeholder="Ej: Dr. José Caicedo — Médico General"
                        value={firmaTexto} onChange={e=>setFirmaTxt(e.target.value)}/>
                      <button type="button" className="btn btn-sm btn-primary"
                        disabled={subiendo==='txt'}
                        onClick={async()=>{
                          setSubiendo('txt');
                          try{
                            await api.post(`/configuracion/usuarios/${editUser}/firma-texto`,{FIRMA_TEXTO:firmaTexto});
                            showToast('✓ Firma de texto guardada');
                          }catch(e){setErrMsg(e.response?.data?.error||e.message);}
                          setSubiendo('');
                        }}>
                        {subiendo==='txt'?'...':'Guardar'}
                      </button>
                    </div>
                  </div>

                  {/* Firma imagen */}
                  <div className="form-group" style={{marginBottom:10}}>
                    <label className="form-label">Firma manuscrita (imagen)</label>
                    <div style={{display:'flex',gap:8,alignItems:'center'}}>
                      {firmaInfo.tiene_firma_img&&(
                        <div style={{padding:'4px 10px',background:'var(--green-lt)',color:'var(--green)',
                          borderRadius:6,fontSize:11,fontWeight:500}}>✅ Imagen cargada</div>
                      )}
                      <label style={{cursor:'pointer'}}>
                        <span className="btn btn-sm" style={{fontSize:11}}>
                          {firmaInfo.tiene_firma_img?'🔄 Cambiar imagen':'📷 Subir imagen'}
                        </span>
                        <input type="file" accept="image/*" style={{display:'none'}}
                          onChange={async e=>{
                            const file=e.target.files[0]; if(!file) return;
                            setSubiendo('img');
                            const fd=new FormData(); fd.append('firma',file);
                            try{
                              await api.post(`/configuracion/usuarios/${editUser}/firma-imagen`,fd,
                                {headers:{'Content-Type':'multipart/form-data'}});
                              showToast('✓ Imagen de firma guardada');
                              setFirmaInfo(fi=>({...fi,tiene_firma_img:true}));
                            }catch(e){setErrMsg(e.response?.data?.error||e.message);}
                            setSubiendo('');
                          }}/>
                      </label>
                    </div>
                  </div>

                  {/* Certificado .p12 */}
                  <div className="form-group">
                    <label className="form-label">Certificado de firma electrónica (.p12)</label>
                    <div style={{display:'flex',gap:6,marginBottom:6,alignItems:'center'}}>
                      {firmaInfo.tiene_p12&&(
                        <div style={{padding:'4px 10px',background:'var(--green-lt)',color:'var(--green)',
                          borderRadius:6,fontSize:11,fontWeight:500}}>✅ Certificado activo</div>
                      )}
                    </div>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6}}>
                      <div>
                        <label style={{fontSize:10,color:'var(--text3)',display:'block',marginBottom:3}}>
                          Contraseña del .p12
                        </label>
                        <input className="form-control" type="password" placeholder="Contraseña del certificado"
                          value={p12Pass} onChange={e=>setP12Pass(e.target.value)}/>
                      </div>
                      <div>
                        <label style={{fontSize:10,color:'var(--text3)',display:'block',marginBottom:3}}>
                          Archivo .p12
                        </label>
                        <label style={{cursor:'pointer',display:'block'}}>
                          <span className="btn btn-sm" style={{fontSize:11,width:'100%',display:'block',textAlign:'center'}}>
                            {subiendo==='p12'?'Verificando...': firmaInfo.tiene_p12?'🔄 Actualizar .p12':'📁 Seleccionar .p12'}
                          </span>
                          <input type="file" accept=".p12" style={{display:'none'}}
                            onChange={async e=>{
                              const file=e.target.files[0]; if(!file) return;
                              if(!p12Pass.trim()){setErrMsg('Ingresa la contraseña del .p12 primero');return;}
                              setSubiendo('p12');
                              const fd=new FormData();
                              fd.append('p12',file);
                              fd.append('p12_pass',p12Pass);
                              try{
                                await api.post(`/configuracion/usuarios/${editUser}/p12`,fd,
                                  {headers:{'Content-Type':'multipart/form-data'}});
                                showToast('✓ Certificado .p12 guardado y verificado');
                                setFirmaInfo(fi=>({...fi,tiene_p12:true}));
                                setP12Pass('');
                              }catch(e){setErrMsg(e.response?.data?.error||e.message);}
                              setSubiendo('');
                            }}/>
                        </label>
                      </div>
                    </div>
                    <div style={{fontSize:10,color:'var(--text3)',marginTop:5}}>
                      ⚠️ La contraseña se almacena cifrada. El .p12 se guarda en el servidor de forma segura.
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div style={{padding:'13px 20px',borderTop:'0.5px solid var(--border)',
              display:'flex',justifyContent:'flex-end',gap:8,background:'var(--bg)',flexShrink:0}}>
              <button className="btn" onClick={()=>setShowModal(false)}>Cancelar</button>
              <button className="btn btn-primary" disabled={saving} onClick={guardarUsuario}>
                {saving?'Guardando...':editUser?'Actualizar usuario':'Crear usuario'}
              </button>
            </div>
          </div>
        </div>
      , document.body)}
      {/* ═══ TARIFARIO ══════════════════════════════════════ */}
      {tab==='tarifario'&&(
        <div>
          {/* IVA Global */}
          <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,
            padding:16,marginBottom:14,display:'flex',alignItems:'center',gap:16,flexWrap:'wrap'}}>
            <div>
              <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'.4px',
                color:'var(--text3)',marginBottom:4}}>IVA vigente (%)</div>
              <div style={{fontSize:12,color:'var(--text2)',maxWidth:320}}>
                Este % se aplica a todos los servicios que tengan marcado "Aplica IVA"
              </div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:8,marginLeft:'auto'}}>
              <input type="number" className="form-control" style={{width:100,textAlign:'right',fontWeight:500,fontSize:18}}
                min="0" max="100" step="0.5"
                value={ivaGlobal}
                onChange={e=>setIvaGlobal(parseFloat(e.target.value)||0)}/>
              <span style={{fontSize:16,fontWeight:500}}>%</span>
            </div>
          </div>

          {/* Tabla servicios */}
          <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'11px 16px',borderBottom:'0.5px solid var(--border)',
              display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <span style={{fontSize:13,fontWeight:500}}>Servicios y precios</span>
              <div style={{display:'flex',gap:8}}>
                <button className="btn btn-sm" onClick={()=>{setNuevoServ({SERVICIO:'',VALOR:0,APLICA_IVA:false,VALOR_MODIFICABLE:true});setShowNuevoServ(true);}}>
                  + Nuevo servicio
                </button>
                <button className="btn btn-primary btn-sm"
                disabled={savingTar}
                onClick={async()=>{
                  setSavingTar(true);
                  try{
                    await api.put('/configuracion/tarifario',{servicios:tarifario,iva_global:ivaGlobal});
                    showToast('✓ Tarifario guardado correctamente');
                  }catch(e){alert(e.response?.data?.error||e.message);}
                  setSavingTar(false);
                }}>
                {savingTar?'Guardando...':'💾 Guardar cambios'}
              </button>
              </div>
            </div>

            {showNuevoServ&&(
              <div style={{padding:14,background:'var(--surface)',borderBottom:'0.5px solid var(--border)'}}>
                <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:8,marginBottom:8}}>
                  <div>
                    <label className="form-label" style={{fontSize:10}}>Nombre del servicio</label>
                    <input className="form-control" style={{fontSize:12}} placeholder="Ej: RADIOGRAFIA DE TORAX"
                      value={nuevoServ.SERVICIO} onChange={e=>setNuevoServ(s=>({...s,SERVICIO:e.target.value}))}/>
                  </div>
                  <div>
                    <label className="form-label" style={{fontSize:10}}>Precio ($)</label>
                    <input type="number" min="0" step="0.01" className="form-control" style={{fontSize:12}}
                      value={nuevoServ.VALOR} onChange={e=>setNuevoServ(s=>({...s,VALOR:parseFloat(e.target.value)||0}))}/>
                  </div>
                </div>
                <div style={{display:'flex',gap:16,marginBottom:10}}>
                  <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12,cursor:'pointer'}}>
                    <input type="checkbox" checked={nuevoServ.APLICA_IVA}
                      onChange={e=>setNuevoServ(s=>({...s,APLICA_IVA:e.target.checked}))} style={{width:14,height:14,cursor:'pointer'}}/>
                    Aplica IVA
                  </label>
                  <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12,cursor:'pointer'}}>
                    <input type="checkbox" checked={nuevoServ.VALOR_MODIFICABLE}
                      onChange={e=>setNuevoServ(s=>({...s,VALOR_MODIFICABLE:e.target.checked}))} style={{width:14,height:14,cursor:'pointer'}}/>
                    Precio modificable
                  </label>
                </div>
                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-primary btn-sm" disabled={savingServ} onClick={async()=>{
                    if(!nuevoServ.SERVICIO.trim())return;
                    setSavingServ(true);
                    try{
                      await api.post('/configuracion/tarifario/servicio',nuevoServ);
                      const r=await api.get('/configuracion/tarifario');
                      setTarifario(r.data.servicios||[]);
                      setShowNuevoServ(false);
                      showToast('✓ Servicio creado');
                    }catch(e){alert(e.response?.data?.error||e.message);}
                    setSavingServ(false);
                  }}>{savingServ?'Guardando...':'Guardar'}</button>
                  <button className="btn btn-sm" onClick={()=>setShowNuevoServ(false)}>Cancelar</button>
                </div>
              </div>
            )}
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr style={{background:'var(--surface)'}}>
                  {['Servicio','Tipo','Precio ($)','Aplica IVA','Precio modificable'].map(h=>(
                    <th key={h} style={{padding:'7px 14px',fontSize:10,fontWeight:600,
                      textTransform:'uppercase',letterSpacing:'.4px',color:'var(--text3)',
                      textAlign:h.includes('$')||h.includes('IVA')||h.includes('mod')?'center':'left',
                      borderBottom:'0.5px solid var(--border)'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tarifario.map((s,i)=>(
                  <tr key={s.COD} style={{borderBottom:'0.5px solid var(--border)'}}>
                    <td style={{padding:'10px 14px',fontWeight:500,fontSize:12}}>{s.SERVICIO}</td>
                    <td style={{padding:'10px 14px'}}>
                      <span style={{fontSize:10,padding:'2px 8px',borderRadius:4,
                        background:'var(--surface)',color:'var(--text3)'}}>
                        {s.TIPO_SERVICIO||'—'}
                      </span>
                    </td>
                    <td style={{padding:'10px 14px',textAlign:'center'}}>
                      <input type="number" min="0" step="0.01"
                        style={{width:90,padding:'4px 8px',border:'0.5px solid var(--border)',
                          borderRadius:6,textAlign:'right',fontSize:12,
                          background:'var(--bg)',color:'var(--text1)'}}
                        value={s.VALOR||0}
                        onChange={e=>{
                          const v = parseFloat(e.target.value)||0;
                          setTarifario(t=>t.map((x,j)=>j===i?{...x,VALOR:v}:x));
                        }}/>
                    </td>
                    <td style={{padding:'10px 14px',textAlign:'center'}}>
                      <input type="checkbox"
                        style={{width:16,height:16,cursor:'pointer'}}
                        checked={!!s.APLICA_IVA}
                        onChange={e=>setTarifario(t=>t.map((x,j)=>j===i?{...x,APLICA_IVA:e.target.checked}:x))}/>
                    </td>
                    <td style={{padding:'10px 14px',textAlign:'center'}}>
                      <input type="checkbox"
                        style={{width:16,height:16,cursor:'pointer'}}
                        checked={s.VALOR_MODIFICABLE==='V'||s.VALOR_MODIFICABLE===true}
                        onChange={e=>setTarifario(t=>t.map((x,j)=>j===i?{...x,VALOR_MODIFICABLE:e.target.checked?'V':'F'}:x))}/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ═══ EXÁMENES Y GRUPOS ═══════════════════════════════ */}
      {tab==='examenes'&&(
        <div style={{display:'grid',gridTemplateColumns:'250px 1fr',gap:14}}>
          {/* Grupos */}
          <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'10px 14px',borderBottom:'0.5px solid var(--border)',fontSize:12,fontWeight:500}}>
              Grupos
            </div>
            {grupos.map(g=>(
              <div key={g.COD}
                onClick={()=>{
                  setGrupoSel(g.COD);
                  api.get(`/laboratorio/config/examenes?grupo=${g.COD}`)
                    .then(r=>setExamList(r.data||[])).catch(()=>{});
                }}
                style={{padding:'8px 14px',cursor:'pointer',fontSize:12,
                  borderBottom:'0.5px solid var(--border)',
                  background:grupoSel===g.COD?'var(--blue-lt)':'',
                  display:'flex',alignItems:'center',gap:8}}>
                <span style={{flex:1}}>{g.TIPO_DETERMINACION}</span>
                <span style={{fontSize:10,padding:'1px 6px',borderRadius:4,
                  background:g.C_FORMULARIO==='IMG'?'#EEF6FF':'var(--green-lt)',
                  color:g.C_FORMULARIO==='IMG'?'#185FA5':'var(--green)'}}>
                  {g.C_FORMULARIO==='IMG'?'Imagen':'Lab'}
                </span>
                <span style={{fontSize:10,color:'var(--text3)'}}>{g.total_examenes}</span>
              </div>
            ))}
          </div>

          {/* Exámenes del grupo */}
          <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'10px 14px',borderBottom:'0.5px solid var(--border)',
              display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <span style={{fontSize:12,fontWeight:500}}>
                {grupoSel?`Exámenes — ${grupos.find(g=>g.COD===grupoSel)?.TIPO_DETERMINACION||''}`:'Selecciona un grupo'}
              </span>
              {grupoSel&&(
                <button className="btn btn-sm btn-primary"
                  onClick={()=>{setFormEx({DETERMINACION:'',COD_TIPO_DETERMINACION:grupoSel,COD_SERVICIO:'',ORDEN_PRESENTACION:1});setShowFormEx(true);}}>
                  + Nuevo examen
                </button>
              )}
            </div>
            {showFormEx&&(
              <div style={{padding:12,background:'var(--surface)',borderBottom:'0.5px solid var(--border)'}}>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:8}}>
                  <div>
                    <label className="form-label">Nombre del examen</label>
                    <input className="form-control" placeholder="Ej: Glucosa basal"
                      value={formEx.DETERMINACION}
                      onChange={e=>setFormEx(f=>({...f,DETERMINACION:e.target.value}))}/>
                  </div>
                  <div>
                    <label className="form-label">Servicio / Precio</label>
                    <select className="form-control" value={formEx.COD_SERVICIO}
                      onChange={e=>setFormEx(f=>({...f,COD_SERVICIO:e.target.value}))}>
                      <option value="">Sin precio</option>
                      {tarifario.map(s=>(
                        <option key={s.COD} value={s.COD}>{s.SERVICIO} — ${Number(s.VALOR||0).toFixed(2)}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <label style={{display:'flex',alignItems:'center',gap:7,fontSize:12,marginBottom:8,cursor:'pointer'}}>
                  <input type="checkbox" checked={!!formEx.ES_EXTERNO}
                    onChange={e=>setFormEx(f=>({...f,ES_EXTERNO:e.target.checked}))} style={{width:14,height:14,cursor:'pointer'}}/>
                  Examen externo (se envía a otro laboratorio)
                </label>
                {formEx.ES_EXTERNO&&(
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:8}}>
                    <div>
                      <label className="form-label" style={{fontSize:10}}>Laboratorio externo</label>
                      <input className="form-control" style={{fontSize:12}}
                        value={formEx.LABORATORIO_EXT||''} onChange={e=>setFormEx(f=>({...f,LABORATORIO_EXT:e.target.value}))}/>
                    </div>
                    <div>
                      <label className="form-label" style={{fontSize:10}}>Costo del laboratorio</label>
                      <input type="number" step="0.01" className="form-control" style={{fontSize:12}}
                        value={formEx.COSTO_EXTERNO||''} onChange={e=>setFormEx(f=>({...f,COSTO_EXTERNO:e.target.value}))}/>
                    </div>
                  </div>
                )}

                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-primary btn-sm" onClick={async()=>{
                    if(!formEx.DETERMINACION.trim())return;
                    try{
                      await api.post('/laboratorio/config/examenes',{
                        ...formEx,
                        ES_EXTERNO:formEx.ES_EXTERNO?'V':'F',
                        LABORATORIO_EXT:formEx.ES_EXTERNO?formEx.LABORATORIO_EXT:null,
                        COSTO_EXTERNO:formEx.ES_EXTERNO?(formEx.COSTO_EXTERNO||null):null,
                      });
                      const r=await api.get(`/laboratorio/config/examenes?grupo=${grupoSel}`);
                      setExamList(r.data||[]);setShowFormEx(false);showToast('✓ Examen creado');
                    }catch(e){alert(e.response?.data?.error||e.message);}
                  }}>Guardar</button>
                  <button className="btn btn-sm" onClick={()=>setShowFormEx(false)}>Cancelar</button>
                </div>
              </div>
            )}
            {!grupoSel&&<div style={{padding:32,textAlign:'center',color:'var(--text3)',fontSize:12}}>← Selecciona un grupo a la izquierda</div>}
            {grupoSel&&examList.length===0&&<div style={{padding:24,textAlign:'center',color:'var(--text3)',fontSize:12}}>No hay exámenes en este grupo</div>}
            {examList.map(ex=>{
              const expandido = examExp===ex.COD;
              const margen = (Number(extDatos.PRECIO_REF||ex.PRECIO||0) - Number(extDatos.COSTO_EXTERNO||0));
              return (
              <div key={ex.COD} style={{borderBottom:'0.5px solid var(--border)'}}>
                <div onClick={()=>{
                    if(expandido){ setExamExp(null); return; }
                    setExamExp(ex.COD);
                    setExtDatos({ ES_EXTERNO:ex.ES_EXTERNO==='V', LABORATORIO_EXT:ex.LABORATORIO_EXT||'',
                      COSTO_EXTERNO:ex.COSTO_EXTERNO||'', PRECIO_REF:ex.PRECIO });
                  }}
                  style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer',
                    padding:'8px 14px',fontSize:12,background:ex.ES_EXTERNO==='V'?'var(--amber-lt)':'transparent'}}>
                  <span style={{flex:1}}>{ex.DETERMINACION}</span>
                  <span style={{fontSize:11,color:ex.ES_EXTERNO==='V'?'var(--amber)':'var(--text3)'}}>
                    {ex.PRECIO>0?`$${Number(ex.PRECIO).toFixed(2)}`:'—'}
                    {ex.ES_EXTERNO==='V'&&ex.COSTO_EXTERNO!=null&&` · margen $${(Number(ex.PRECIO||0)-Number(ex.COSTO_EXTERNO||0)).toFixed(2)}`}
                  </span>
                  {ex.ES_EXTERNO==='V'&&<span style={{fontSize:10,padding:'1px 6px',borderRadius:4,background:'var(--amber)',color:'#fff'}}>Externo</span>}
                  <span style={{fontSize:10,padding:'1px 6px',borderRadius:4,
                    background:ex.ACTIVO==='V'?'var(--green-lt)':'var(--red-lt)',
                    color:ex.ACTIVO==='V'?'var(--green)':'var(--red)'}}>
                    {ex.ACTIVO==='V'?'Activo':'Inactivo'}
                  </span>
                  <i className={`ti ti-chevron-${expandido?'up':'down'}`} style={{fontSize:13,color:'var(--text3)'}} aria-hidden="true"></i>
                </div>

                {expandido&&(
                  <div style={{padding:14,background:'var(--bg)'}}>
                    <label style={{display:'flex',alignItems:'center',gap:7,fontSize:12,marginBottom:10,cursor:'pointer'}}>
                      <input type="checkbox" checked={!!extDatos.ES_EXTERNO}
                        onChange={e=>setExtDatos(d=>({...d,ES_EXTERNO:e.target.checked}))} style={{width:14,height:14,cursor:'pointer'}}/>
                      Examen externo (se envía a otro laboratorio)
                    </label>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:10,marginBottom:10}}>
                      <div>
                        <label className="form-label" style={{fontSize:10}}>Laboratorio externo</label>
                        <input className="form-control" style={{fontSize:12}} disabled={!extDatos.ES_EXTERNO}
                          value={extDatos.LABORATORIO_EXT||''} onChange={e=>setExtDatos(d=>({...d,LABORATORIO_EXT:e.target.value}))}/>
                      </div>
                      <div>
                        <label className="form-label" style={{fontSize:10}}>Precio al paciente</label>
                        <input className="form-control" style={{fontSize:12,background:'var(--border)',color:'var(--text3)'}}
                          value={Number(ex.PRECIO||0).toFixed(2)} disabled/>
                        <div style={{fontSize:9.5,color:'var(--text3)',marginTop:2}}>se edita en Tarifario</div>
                      </div>
                      <div>
                        <label className="form-label" style={{fontSize:10}}>Costo del laboratorio</label>
                        <input type="number" step="0.01" className="form-control" style={{fontSize:12}} disabled={!extDatos.ES_EXTERNO}
                          value={extDatos.COSTO_EXTERNO||''} onChange={e=>setExtDatos(d=>({...d,COSTO_EXTERNO:e.target.value}))}/>
                      </div>
                    </div>
                    {extDatos.ES_EXTERNO&&(
                      <div style={{fontSize:12,color:margen>=0?'var(--green)':'var(--red)',
                        background:margen>=0?'var(--green-lt)':'var(--red-lt)',padding:'6px 10px',borderRadius:6,display:'inline-block',marginBottom:10}}>
                        Margen: ${margen.toFixed(2)}{ex.PRECIO>0&&` (${((margen/Number(ex.PRECIO))*100).toFixed(1)}%)`}
                      </div>
                    )}
                    <div style={{display:'flex',gap:8}}>
                      <button className="btn btn-sm" style={{background:'var(--navy)',color:'#fff',border:'none'}}
                        disabled={extSaving}
                        onClick={async()=>{
                          setExtSaving(true);
                          try{
                            await api.put(`/laboratorio/config/examenes/${ex.COD}`,{
                              DETERMINACION:ex.DETERMINACION, COD_SERVICIO:ex.COD_SERVICIO,
                              ORDEN_PRESENTACION:ex.ORDEN_PRESENTACION, ACTIVO:ex.ACTIVO,
                              ES_EXTERNO:extDatos.ES_EXTERNO?'V':'F',
                              LABORATORIO_EXT:extDatos.ES_EXTERNO?extDatos.LABORATORIO_EXT:null,
                              COSTO_EXTERNO:extDatos.ES_EXTERNO?(extDatos.COSTO_EXTERNO||null):null,
                            });
                            const r=await api.get(`/laboratorio/config/examenes?grupo=${grupoSel}`);
                            setExamList(r.data||[]);
                            setExamExp(null);
                            showToast('✓ Guardado');
                          }catch(err){ showToast('Error: '+(err.response?.data?.error||err.message)); }
                          finally{ setExtSaving(false); }
                        }}>{extSaving?'Guardando...':'Guardar'}</button>
                      <button className="btn btn-sm" onClick={()=>setExamExp(null)}>Cancelar</button>
                    </div>
                  </div>
                )}
              </div>
            );})}
          </div>
        </div>
      )}

      {/* ═══ PLANTILLAS DE CONSULTA ════════════════════════ */}
      {tab==='plantillas'&&(
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontSize:12,color:'var(--text2)'}}>
              Plantillas de <strong>{usuario?.nombres}</strong>
            </div>
            <button className="btn btn-primary btn-sm"
              onClick={()=>{setFormPl({NOMBRE:'',DESCRIPCION:'',EVOLUCION:'',diagnosticos:[]});setEditPl(null);setShowFormPl(true);}}>
              + Nueva plantilla
            </button>
          </div>

          {/* Formulario nueva/editar plantilla */}
          {showFormPl&&(
            <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,padding:14}}>
              <div style={{fontSize:12,fontWeight:500,marginBottom:10}}>
                {editPl?'Editar plantilla':'Nueva plantilla'}
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:8}}>
                <div>
                  <label className="form-label">Nombre</label>
                  <input className="form-control" placeholder="Ej: Control hipotiroidismo"
                    value={formPl.NOMBRE} onChange={e=>setFormPl(f=>({...f,NOMBRE:e.target.value}))}/>
                </div>
                <div>
                  <label className="form-label">Descripción (opcional)</label>
                  <input className="form-control" placeholder="Descripción breve"
                    value={formPl.DESCRIPCION} onChange={e=>setFormPl(f=>({...f,DESCRIPCION:e.target.value}))}/>
                </div>
              </div>
              <div style={{marginBottom:8}}>
                <label className="form-label">Texto de evolución</label>
                <textarea className="form-control" rows={4}
                  placeholder="Motivo de consulta, examen físico, plan terapéutico..."
                  value={formPl.EVOLUCION} onChange={e=>setFormPl(f=>({...f,EVOLUCION:e.target.value}))}
                  style={{resize:'vertical'}}/>
              </div>
              <div style={{marginBottom:8}}>
                <label className="form-label">Diagnósticos CIE-10</label>
                <div style={{position:'relative',marginBottom:6}}>
                  <input className="form-control" placeholder="Buscar CIE-10..."
                    value={busqCie} onChange={async e=>{
                      setBusqCie(e.target.value);
                      if(e.target.value.length>1){
                        try{const{data}=await api.get(`/historia/cie10?q=${encodeURIComponent(e.target.value)}`);setSugsCie(data||[]);}catch{}
                      } else setSugsCie([]);
                    }}/>
                  {sugsCie.length>0&&(
                    <div style={{position:'absolute',top:'100%',left:0,right:0,background:'var(--bg)',
                      border:'0.5px solid var(--border)',borderRadius:8,zIndex:50,maxHeight:180,overflowY:'auto',marginTop:4}}>
                      {sugsCie.map(c=>(
                        <div key={c.COD} style={{padding:'6px 10px',cursor:'pointer',fontSize:12,
                          borderBottom:'0.5px solid var(--border)'}}
                          onMouseEnter={e=>e.currentTarget.style.background='var(--surface)'}
                          onMouseLeave={e=>e.currentTarget.style.background=''}
                          onClick={()=>{
                            setFormPl(f=>({...f,diagnosticos:[...f.diagnosticos,{COD_CIE10:c.COD,DESCRIPCION_CIE:c.DESCRIPCION}]}));
                            setBusqCie('');setSugsCie([]);
                          }}>
                          <span style={{color:'var(--navy-lt)',fontWeight:500,marginRight:8}}>{c.COD}</span>
                          {c.DESCRIPCION}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {formPl.diagnosticos.map((d,i)=>(
                  <div key={i} style={{display:'flex',alignItems:'center',gap:8,padding:'4px 8px',
                    background:'var(--surface)',borderRadius:6,marginBottom:4,fontSize:12}}>
                    <span style={{color:'var(--navy-lt)',fontWeight:500}}>{d.COD_CIE10}</span>
                    <span style={{flex:1}}>{d.DESCRIPCION_CIE}</span>
                    <button style={{background:'none',border:'none',cursor:'pointer',color:'var(--text3)',fontSize:14}}
                      onClick={()=>setFormPl(f=>({...f,diagnosticos:f.diagnosticos.filter((_,j)=>j!==i)}))}>×</button>
                  </div>
                ))}
              </div>
              <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
                <button className="btn btn-sm" onClick={()=>setShowFormPl(false)}>Cancelar</button>
                <button className="btn btn-primary btn-sm" onClick={async()=>{
                  if(!formPl.NOMBRE||!formPl.EVOLUCION){alert('Nombre y evolución son requeridos');return;}
                  try{
                    if(editPl){
                      await api.put(`/historia/plantillas-consulta/${editPl}`,{...formPl,usuario:usuario?.usuario});
                    } else {
                      await api.post('/historia/plantillas-consulta',{...formPl,usuario:usuario?.usuario});
                    }
                    const r=await api.get(`/historia/plantillas-consulta?medico=${usuario?.usuario}`);
                    setPlantillasC(r.data||[]);
                    setShowFormPl(false);showToast('✓ Plantilla guardada');
                  }catch(e){alert(e.response?.data?.error||e.message);}
                }}>Guardar</button>
              </div>
            </div>
          )}

          {/* Lista de plantillas */}
          {plantillasC.length===0&&!showFormPl&&(
            <div style={{padding:32,textAlign:'center',color:'var(--text3)',fontSize:12}}>
              No tienes plantillas creadas — crea la primera
            </div>
          )}
          {plantillasC.map(p=>(
            <div key={p.COD} style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,padding:12}}>
              <div style={{display:'flex',alignItems:'flex-start',gap:10}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:500}}>{p.NOMBRE}</div>
                  {p.DESCRIPCION&&<div style={{fontSize:11,color:'var(--text3)',marginTop:2}}>{p.DESCRIPCION}</div>}
                  <div style={{fontSize:11,color:'var(--text2)',marginTop:6,lineHeight:1.5,
                    maxHeight:60,overflow:'hidden',textOverflow:'ellipsis'}}>
                    {p.EVOLUCION}
                  </div>
                  {p.diagnosticos?.length>0&&(
                    <div style={{display:'flex',flexWrap:'wrap',gap:4,marginTop:6}}>
                      {p.diagnosticos.map(d=>(
                        <span key={d.COD_CIE10} style={{fontSize:10,padding:'1px 7px',borderRadius:4,
                          background:'var(--blue-lt)',color:'var(--navy-lt)'}}>
                          {d.COD_CIE10} — {d.DESCRIPCION_CIE}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <div style={{display:'flex',gap:6,flexShrink:0}}>
                  <button className="btn btn-sm" onClick={()=>{
                    setFormPl({NOMBRE:p.NOMBRE,DESCRIPCION:p.DESCRIPCION||'',
                      EVOLUCION:p.EVOLUCION,diagnosticos:p.diagnosticos||[]});
                    setEditPl(p.COD);setShowFormPl(true);
                  }}>✏️ Editar</button>
                  <button className="btn btn-sm" style={{color:'var(--red)'}}
                    onClick={async()=>{
                      if(!window.confirm('¿Eliminar esta plantilla?'))return;
                      await api.delete(`/historia/plantillas-consulta/${p.COD}`);
                      setPlantillasC(pp=>pp.filter(x=>x.COD!==p.COD));
                    }}>🗑</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ═══ CONSENTIMIENTOS INFORMADOS ═══════════════════════ */}
      {tab==='consentimientos'&&(
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <span style={{fontSize:13,fontWeight:500}}>Plantillas de consentimiento informado</span>
            <button className="btn btn-primary btn-sm" onClick={()=>{
              setFormConsent({TITULO:'',CUERPO:'',REQUIERE_FIRMA_MEDICO:false,REQUIERE_FIRMA_TESTIGO:false});
              setEditConsentId(null); setShowFormConsent(true);
            }}>+ Nueva plantilla</button>
          </div>

          {showFormConsent&&(
            <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,padding:16}}>
              <div style={{marginBottom:10}}>
                <label className="form-label">Título</label>
                <input className="form-control" placeholder="Ej: Consentimiento para Cirugía Menor"
                  value={formConsent.TITULO} onChange={e=>setFormConsent(f=>({...f,TITULO:e.target.value}))}/>
              </div>
              <div style={{marginBottom:10}}>
                <label className="form-label">Cuerpo del documento (texto legal completo)</label>
                <textarea className="form-control" rows={10} style={{fontFamily:'inherit',fontSize:12,lineHeight:1.5}}
                  placeholder="Separar secciones con una línea en blanco. Las líneas que empiecen con un número (Ej: '1. Identificación...') se muestran como subtítulo."
                  value={formConsent.CUERPO} onChange={e=>setFormConsent(f=>({...f,CUERPO:e.target.value}))}/>
              </div>
              <div style={{display:'flex',gap:16,marginBottom:12}}>
                <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12,cursor:'pointer'}}>
                  <input type="checkbox" checked={formConsent.REQUIERE_FIRMA_MEDICO}
                    onChange={e=>setFormConsent(f=>({...f,REQUIERE_FIRMA_MEDICO:e.target.checked}))} style={{width:14,height:14,cursor:'pointer'}}/>
                  Requiere firma del médico
                </label>
                <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12,cursor:'pointer'}}>
                  <input type="checkbox" checked={formConsent.REQUIERE_FIRMA_TESTIGO}
                    onChange={e=>setFormConsent(f=>({...f,REQUIERE_FIRMA_TESTIGO:e.target.checked}))} style={{width:14,height:14,cursor:'pointer'}}/>
                  Requiere firma de testigo
                </label>
              </div>
              <div style={{display:'flex',gap:6}}>
                <button className="btn btn-primary btn-sm" disabled={savingConsent} onClick={async()=>{
                  if(!formConsent.TITULO.trim()||!formConsent.CUERPO.trim())return;
                  setSavingConsent(true);
                  try{
                    if(editConsentId) await api.put(`/historia/plantillas-consentimiento/${editConsentId}`,formConsent);
                    else await api.post('/historia/plantillas-consentimiento',formConsent);
                    const r=await api.get('/historia/plantillas-consentimiento');
                    setPlantillasConsent(r.data||[]);
                    setShowFormConsent(false);
                    showToast(editConsentId?'✓ Plantilla actualizada':'✓ Plantilla creada');
                  }catch(e){alert(e.response?.data?.error||e.message);}
                  setSavingConsent(false);
                }}>{savingConsent?'Guardando...':'Guardar'}</button>
                <button className="btn btn-sm" onClick={()=>setShowFormConsent(false)}>Cancelar</button>
              </div>
            </div>
          )}

          {plantillasConsent.length===0&&!showFormConsent&&(
            <div style={{padding:24,textAlign:'center',color:'var(--text3)',fontSize:12}}>Sin plantillas de consentimiento creadas</div>
          )}
          {plantillasConsent.map(p=>(
            <div key={p.COD} style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,padding:14}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                <div>
                  <div style={{fontSize:13,fontWeight:600}}>{p.TITULO}</div>
                  <div style={{display:'flex',gap:6,marginTop:4}}>
                    {p.REQUIERE_FIRMA_MEDICO==='V'&&<span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'var(--blue-lt)',color:'var(--navy)'}}>Firma médico</span>}
                    {p.REQUIERE_FIRMA_TESTIGO==='V'&&<span style={{fontSize:9,padding:'1px 6px',borderRadius:4,background:'var(--amber-lt)',color:'var(--amber)'}}>Firma testigo</span>}
                  </div>
                </div>
                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-sm" style={{fontSize:11}} onClick={()=>{
                    setFormConsent({TITULO:p.TITULO,CUERPO:p.CUERPO,
                      REQUIERE_FIRMA_MEDICO:p.REQUIERE_FIRMA_MEDICO==='V',REQUIERE_FIRMA_TESTIGO:p.REQUIERE_FIRMA_TESTIGO==='V'});
                    setEditConsentId(p.COD); setShowFormConsent(true);
                  }}>✏️ Editar</button>
                  <button className="btn btn-sm" style={{fontSize:11,color:'var(--red)'}} onClick={async()=>{
                    if(!window.confirm('¿Eliminar esta plantilla?'))return;
                    await api.delete(`/historia/plantillas-consentimiento/${p.COD}`);
                    setPlantillasConsent(pp=>pp.filter(x=>x.COD!==p.COD));
                  }}>🗑</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ═══ ASISTENTE IA ═══════════════════════════════════ */}
      {tab==='ia'&&(
        <div style={{display:'flex',flexDirection:'column',gap:12}}>

          {/* Estado actual */}
          <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,padding:14}}>
            <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12}}>
              <div style={{width:44,height:44,borderRadius:'50%',background:'var(--blue-lt)',
                display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,flexShrink:0}}>🤖</div>
              <div>
                <div style={{fontSize:13,fontWeight:500}}>Asistente IA para consultas médicas</div>
                <div style={{fontSize:11,color:'var(--text3)',marginTop:2}}>
                  Graba la consulta médico-paciente y genera automáticamente la evolución y diagnósticos CIE-10
                </div>
              </div>
              <span style={{marginLeft:'auto',fontSize:11,padding:'3px 10px',borderRadius:20,fontWeight:500,
                background:iaCfg.configurado?'var(--green-lt)':'var(--surface)',
                color:iaCfg.configurado?'var(--green)':'var(--text3)'}}>
                {iaCfg.configurado?'✓ Configurado':'No configurado'}
              </span>
            </div>

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:12}}>
              {[['🎙️ Whisper','Transcripción de voz a texto en español'],
                ['🧠 GPT-4o mini','Análisis médico y generación de borrador'],
                ['🔒 Privacidad','El audio no se almacena en OpenAI'],
                ['💰 Costo','~$0.01–0.05 USD por consulta']
              ].map(([icon,txt])=>(
                <div key={icon} style={{background:'var(--surface)',borderRadius:8,padding:'8px 10px',
                  display:'flex',gap:8,alignItems:'flex-start'}}>
                  <span style={{fontSize:16,flexShrink:0}}>{icon}</span>
                  <span style={{fontSize:11,color:'var(--text2)'}}>{txt}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Configurar API Key */}
          <div style={{background:'var(--bg)',border:'0.5px solid var(--border)',borderRadius:10,padding:14}}>
            <div style={{fontSize:12,fontWeight:500,marginBottom:10}}>Configurar API Key de OpenAI</div>
            <div style={{fontSize:11,color:'var(--text3)',marginBottom:10}}>
              Obtén tu API Key en <span style={{color:'var(--navy-lt)'}}>platform.openai.com</span> → API Keys → Create new secret key
            </div>
            <div style={{display:'flex',gap:8,marginBottom:10}}>
              <div style={{flex:1,position:'relative'}}>
                <input className="form-control"
                  type={showKey?'text':'password'}
                  placeholder="sk-proj-..."
                  value={iaCfg.api_key}
                  onChange={e=>setIaCfg(c=>({...c,api_key:e.target.value}))}
                  style={{paddingRight:36}}/>
                <button type="button"
                  style={{position:'absolute',right:8,top:'50%',transform:'translateY(-50%)',
                    background:'none',border:'none',cursor:'pointer',fontSize:14,color:'var(--text3)'}}
                  onClick={()=>setShowKey(s=>!s)}>
                  {showKey?'🙈':'👁️'}
                </button>
              </div>
              <button className="btn btn-primary"
                disabled={savingIA||!iaCfg.api_key.startsWith('sk-')}
                onClick={async()=>{
                  setSavingIA(true);
                  try{
                    await api.post('/historia/ia-config',{api_key:iaCfg.api_key});
                    setIaCfg(c=>({...c,configurado:true}));
                    showToast('✓ API Key guardada correctamente');
                  }catch(e){alert(e.response?.data?.error||e.message);}
                  setSavingIA(false);
                }}>
                {savingIA?'Guardando...':'Guardar'}
              </button>
            </div>
            {iaCfg.configurado&&(
              <div style={{fontSize:11,color:'var(--green)',background:'var(--green-lt)',
                padding:'6px 10px',borderRadius:6}}>
                ✓ API Key configurada. El asistente IA está activo en el módulo de Historia Clínica.
              </div>
            )}
            {!iaCfg.configurado&&(
              <div style={{fontSize:11,color:'var(--text3)',background:'var(--surface)',
                padding:'6px 10px',borderRadius:6}}>
                Sin API Key configurada. El botón de micrófono no aparecerá en las consultas.
              </div>
            )}
          </div>
        </div>
      )}

    </div>
  );
}
